(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/cookies-check-and-info/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/components/cookies-check-and-info/assets/javascripts/prescript.js'); 
var svs = svs || {};
svs.components = svs.components || {};
svs.components.cookies_check_and_info =
  svs.components.cookies_check_and_info || {};
svs.components.cookies_check_and_info.views =
  svs.components.cookies_check_and_info.views || {};
svs.components.cookies_check_and_info.templates =
  svs.components.cookies_check_and_info.templates || {};
svs.components.cookies_check_and_info.data =
  svs.components.cookies_check_and_info.data || {};

 })(window);